import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SaraLogo } from '@/components/SaraLogo';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const ThankYouPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Fire Google Analytics lead event
    if (window.gtag) {
      window.gtag('event', 'generate_lead', {
        event_category: 'form',
        event_label: 'contact_form_submission',
        value: 1
      });
    }

    // PLACEHOLDER: Add your Google Ads conversion tracking below
    // When you set up your Google Ads conversion action, paste the snippet here:
    // if (window.gtag) {
    //   window.gtag('event', 'conversion', {
    //     'send_to': 'AW-YOUR_CONVERSION_ID/YOUR_CONVERSION_LABEL',
    //   });
    // }
  }, []);

  return (
    <div data-testid="thank-you-page" className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-8">
          <SaraLogo variant="light" size="large" />
        </div>
        <div className="bg-card rounded-2xl shadow-[var(--shadow-elevated)] p-8 sm:p-10 border border-border">
          <div className="w-16 h-16 rounded-full bg-accent flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-primary" />
          </div>
          <h1 data-testid="thank-you-heading" className="text-3xl font-bold text-foreground mb-4">Thank You!</h1>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            Your request has been received. I'll be in touch with you shortly to schedule your free audit.
          </p>
          <Button data-testid="back-home-btn" onClick={() => navigate('/')} className="gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
